<template>
  <v-dialog transition="scale-transition" origin="center center" max-width="460" v-model="dialogDeposit"
    content-class="deposit-withdraw-popup marketingPopup">
    <template v-slot:activator="{ on, attrs }">
      <span class="text-decoration-none" v-bind="attrs" v-on="on">Credit In / Out</span>
    </template>
    <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
      <v-card-title class="pb-3 text-left justify-start pl-3">
        Credit In / Out
      </v-card-title>
      <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
        Transfer Credit From Here
      </v-card-subtitle>
      <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
        <v-row>
          <v-col cols="12">
            <fieldset>
              <legend>Transaction Type*</legend>
              <v-select v-model="selectedTrxType" solo :items="trx_type" item-text="text" item-value="value"
                append-icon="mdi-chevron-down" label="Click to Select" class="custom-select" hide-details></v-select>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>MT5 Account*</legend>
              <v-select v-model="selectedAccount" solo :items="tradingAcc" item-text="text" item-value="value"
                append-icon="mdi-chevron-down" label="Select Your Acc." class="custom-select" hide-details></v-select>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>Amount*</legend>
              <v-text-field type="number" v-model="amount" label="USD" single-line solo hide-details
                class="custom-select"></v-text-field>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>Comment*</legend>
              <v-text-field v-model="comment" label="Write Here" single-line solo hide-details
                class="custom-select"></v-text-field>
            </fieldset>
          </v-col>
        </v-row>
      </v-card>
      <v-card-actions>
        <v-row dense>
          <v-col cols="12">
            <v-btn tile @click="submitForm" elevation="0" class="text-capitalize btn-account mr-3 px-sm-8"
              color="greenMain">Confirm</v-btn>
            <v-btn tile color="#FF567F" @click="dialogDeposit = false" elevation="0"
              class="text-capitalize btn-account px-sm-8">Cancel</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { REGISTERUSERDETAILS__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      dialogDeposit: false,
      userId: "",
      trx_type: [
        { text: "Credit In", value: 0 },
        { text: "Credit Out", value: 1 },
      ],
      selectedTrxType: null,
      selectedAccount: null,
      amount: null,
      comment: "",
    };
  },
  computed: {
    ...mapState("reguserdetails", ["tradingAcc"]),
  },
  methods: {
    ...mapActions("reguserdetails", [REGISTERUSERDETAILS__ACTIONS.CLIENTTRADINGACCOUNTS, REGISTERUSERDETAILS__ACTIONS.CREATECLIENTCREDITINOUT]),
    submitForm() {
      const formData = {
        client_account_id: this.userId,
        credit_type: this.selectedTrxType,
        trading_account_no: this.selectedAccount,
        amount: this.amount,
        comment: this.comment
      };
      this[REGISTERUSERDETAILS__ACTIONS.CREATECLIENTCREDITINOUT](formData)
      this.dialogDeposit = false;
      this.selectedTrxType = '';
      this.selectedAccount = '';
      this.amount = '';
      this.comment = '';
    }
  },
  async mounted() {
    this.userId = this.$route.params.id;
    await this[REGISTERUSERDETAILS__ACTIONS.CLIENTTRADINGACCOUNTS](this.$route.params.id);
  },
};
</script>